import { cn } from '@talentmesh/ui/lib/utils';

import { LoaderCircle } from 'lucide-react';

export function MRT_LoadingOverlay({
    className,
    spinner = true,
    visible,
    zIndex = 2,
    ...props
}: {
    spinner?: boolean;
    visible?: boolean;
    zIndex?: number;
} & React.HTMLAttributes<HTMLDivElement>) {
    if (!visible) return null;
    return (
        <div
            className={cn('bg-background/60 absolute inset-0 flex items-center justify-center', className)}
            style={{ zIndex }}
            {...props}
        >
            {spinner && <LoaderCircle className={cn('text-primary h-8 w-8 animate-spin')} />}
        </div>
    );
}
